import React, {useEffect, useRef, useState} from "react";
import styled, {keyframes}  from "styled-components";
import {Tokens, Video} from "../components/DesignSystem";

const StyledMessageTrigger = styled.div`
    display: inline-block;
    position: relative;
    @media ${Tokens.md} {
        position: static;   
    }
   .trigger {
        display: inline-block;
        transition: all 0.2s;
        background: transparent;
        border-radius: 8px;
        padding: 2px 10px;
        margin-left: -10px;
        margin-right: -10px;
       
   }
    &:hover .trigger {
        background: var(--alphaBlack20);
        @media ${Tokens.md} {
            
        }
    }
`;

const messageSlide = keyframes`
    0% {
        transform: translateY(-20px);
    }
    100% {
        transform: translateY(0);
    }
`;

const StyledMessage = styled.div`
    background: var(--white);
    color: var(--darkBlue);
    width: 26rem;
    max-width: 100vw;
    position: absolute;
    top: 100px; left: -10px;
    z-index: 30;
    margin-right: -29rem;
    padding: 1rem;
    border-radius: 1rem;
    font-weight: var(--normal);
    font-size: var(--fontSizeM);
    line-height: 1.4;
    box-shadow: 0 2rem 10rem var(--alphaBlack20);
    transform: translateY(-20px);
    transition: all 0.2s var(--customEasing);
    opacity: 0;

    /* &.animated {
        animation: ${messageSlide} 0.2s var(--customEasing);
    } */
    &.visible {
        opacity: 1;
        transform: translateY(0);
 
    }
    @media ${Tokens.md} {
        position: fixed;
        top: auto;
        bottom: 0;
        left: 50%;
        border-radius: 1rem 1rem 0 0;
        margin-left: 0;
        transform: translateX(-50%) translateY(100%);
        &.visible {
            transform: translateX(-50%) translateY(0);
        }
        svg {
            display: none;
        }
    }
    /* visibility: hidden; */
    svg {
        fill: var(--white);
        position: absolute;
        top: -13px;
        /* top: 44px;
        left: -20px; */
        /* left: calc(50% - 16px); */
        left: 20px;
        transform: rotate(180deg);
    }
    a {
        font-weight: var(--bold);
        display: inline-block;
        padding: 4px 8px;
        margin: 10px 8px -4px -8px;
        border-radius: 4px;
        font-size: var(--fontSizeXS);
        text-transform: uppercase;
        &:hover {
            background: var(--alphaBlack10);
        }
        &:active {
            background: var(--alphaBlack20);
        }
    
        &::before {
            content: "";
            display: inline-block;
            width: 0.6rem;
            height: 0.6rem;
            border-radius: 0.6rem;
            background: #3b5998;
            margin-right: 0.5rem;
        }
    
    }
    video {
        width: 100%;
        border-radius: 0.5rem;
    }
    main {
        padding: 0.7rem 0.5rem 0.5rem 0.5rem;
    }
    a#instagram {
        &::before {
            background: #d6249f;
            background: radial-gradient(circle at 30% 107%, #fdf497 0%, #fdf497 5%, #fd5949 45%,#d6249f 60%,#285AEB 90%);
        }
    }
    a#linkedin {
        &::before {
            background: #2867B2;
        }
    }
`;

const MessageContent = ({trigger, message}) => {
    return <React.Fragment>
        <Video key={trigger}
                    src={`/gif/${trigger}.mp4`}></Video>
                    <main>{message}</main>
                    <svg width="32" height="15" viewBox="0 0 32 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M13.1716 13.1716L0 0H32L18.8284 13.1716C17.2663 14.7337 14.7337 14.7337 13.1716 13.1716Z" />
        </svg>
    </React.Fragment>;
}

const IntroMessage = ({trigger, message, children}) => {
    const ref = useRef();
    const [showed, setShowed] = useState(false);
    useEffect(() => {
        if (ref && ref.current != null) {
            if(showed) {
                // ref.current.style.display = '';
                ref.current.classList.add('visible');
            }
            else {
                ref.current.classList.remove('visible');
                const removeDom = () => {
                    setShowed(false);
                    ref.current.removeEventListener('transitionend', removeDom);
                }
                ref.current.addEventListener('transitionend', removeDom);   
            }
        }
    }, [showed, ref]);
    return (
        <StyledMessageTrigger
        onMouseEnter={() => {
            setShowed(true);
        }}
        onMouseLeave={() => {
            setShowed(false)
        }}>
        <div className="trigger">{children}</div>
   
        {showed &&
        <StyledMessage ref={ref}>
        <MessageContent trigger={trigger} message={message} />
        </StyledMessage>
        }
        
      </StyledMessageTrigger>
        
    )
}

export default IntroMessage;